import axios from "axios";
import CustomInterceptors from "@/api/GAInterceptors";

const InstanceGA = axios.create({
    baseURL: process.env.VUE_APP_GLOBALAUTH_API
});

InstanceGA.interceptors.request.use(CustomInterceptors.GAInterceptors);

InstanceGA.interceptors.response.use(response => {
    return response;
}, CustomInterceptors.GAInterceptorsOnError);

export default InstanceGA;